// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core'

// Import bar charts, all suffixed with Chart
import {
  TreemapChart,
  GaugeChart,
  MapChart,
  LineChart,
  BarChart,
  ScatterChart,
  PieChart,
  CustomChart
} from 'echarts/charts'

// Import the title, tooltip, rectangular coordinate system, dataset and transform components
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  VisualMapComponent,
  ToolboxComponent,
  DataZoomSliderComponent,
  DataZoomInsideComponent,
  LegendComponent,
  GraphicComponent
} from 'echarts/components'

// Features like Universal Transition and Label Layout
import { LabelLayout, UniversalTransition } from 'echarts/features'

// Import the Canvas renderer
// Note that including the CanvasRenderer or SVGRenderer is a required step
import { CanvasRenderer } from 'echarts/renderers'

// Register the required components
echarts.use([
  TreemapChart,
  GaugeChart,
  MapChart,
  LineChart,
  BarChart,
  ScatterChart,
  PieChart,
  CustomChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  VisualMapComponent,
  ToolboxComponent,
  DataZoomSliderComponent,
  DataZoomInsideComponent,
  LegendComponent,
  GraphicComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
])

export default echarts
